// components/Slider/Slider.jsx
import React from "react";
import "./Slider.css";

const parseSeconds = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 40;
};

/**
 * Infinite logo marquee. The base list is repeated until one loop half is
 * wide enough for large viewports, then rendered twice; the CSS animation
 * translates exactly -50%, so the loop is seamless (no jump on restart).
 * `speedDesktop` / `speedMobile` describe the duration of one full pass of
 * the base list, e.g. "20s".
 */
const Slider = ({ items, renderItem, speedDesktop = "40s", speedMobile = "30s", label }) => {
  const MIN_ITEMS_PER_HALF = 12;
  const repetitions = Math.max(1, Math.ceil(MIN_ITEMS_PER_HALF / items.length));
  const half = Array.from({ length: repetitions }, () => items).flat();

  const trackStyle = {
    "--slider-speed-desktop": `${parseSeconds(speedDesktop) * repetitions}s`,
    "--slider-speed-mobile": `${parseSeconds(speedMobile) * repetitions}s`,
  };

  return (
    <section className="slider-section" aria-label={label || "Logo-Slider"}>
      {label && <p className="slider-label">{label}</p>}
      <div className="slider-container">
        <div className="slider-track" style={trackStyle}>
          {[false, true].map((isClone) =>
            half.map((item, index) => (
              <div
                className="slider-item"
                key={`${isClone ? "clone" : "base"}-${index}`}
                aria-hidden={isClone || undefined}
              >
                {renderItem(item)}
              </div>
            ))
          )}
        </div>
      </div>
    </section>
  );
};

export default Slider;
